"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.RECAPTCHA_SETTINGS = new core_1.InjectionToken('recaptcha-settings');



//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/ng-recaptcha/recaptcha/recaptcha-settings.js
// module id = ../../../../ng-recaptcha/recaptcha/recaptcha-settings.js
// module chunks = 3